module.exports = __webpack_public_path__ + "media/images/ir/profile/photo_chiba-1666a183e07171babeed3e482321683b.jpg";